import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Input } from '@shared/components/ui';
import { ROUTES } from '@shared/constants/routes';

interface SearchBarProps {
  className?: string;
  onSearch?: () => void;
}

export function SearchBar({ className = '', onSearch }: SearchBarProps) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`${ROUTES.CATALOG}?search=${encodeURIComponent(query.trim())}`);
      setQuery('');
      onSearch?.();
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`relative ${className}`}>
      <Input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Buscar productos..."
        maxLength={100}
        className="pr-10"
      />
      <button
        type="submit"
        className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-brand-mauve transition-colors"
        aria-label="Buscar"
      >
        <Search className="h-5 w-5" />
      </button>
    </form>
  );
}
